// The reset token lives in the URL fragment (#token=...): browsers never send it to servers,
// so it stays out of access logs and Referer headers.
const getResetToken = hash => new URLSearchParams(hash.replace(/^#/, '')).get('token')

export default getResetToken
